import React, { Fragment } from "react";
import { Format, Tile } from "@redriver/cinnamon";
import { LightboxImage } from "components/containers";
import {
  Icon,
  Image,
  Popup,
  PopupContent,
  PopupHeader,
} from "semantic-ui-react";
import Document from "assets/icons/document-alt.svg";
import Pdf from "assets/icons/pdf.svg";
import Excel from "assets/icons/excel.svg";
const ThumbnailTile = ({
  document,
  typeActions,
  imageArray,
  imageIndex,
  sendToAppTitle = "Sent to the app",
}) => {
  const actionsNode =
    typeof typeActions === "function" ? typeActions(document) : typeActions;
  return (
    <Popup
      trigger={
        <Tile className={`document-tile`}>
          <div className={`document-thumbnail`}>
            {document.imageUrl ? (
              <LightboxImage
                key={document.blobId}
                src={document.imageUrl}
                style={{ cursor: "pointer" }}
                photoIndex={imageIndex}
                imageArray={imageArray}
              />
            ) : document.fileExtension.toLowerCase().includes("pdf") ? (
              <Image src={Pdf} style={{ width: "40%", height: "40%" }} />
            ) : document.fileExtension.toLowerCase().includes("xls") ||
              document.fileExtension.toLowerCase().includes("xlsx") ? (
              <Image src={Excel} style={{ width: "40%", height: "40%" }} />
            ) : (
              <Image src={Document} style={{ width: "40%", height: "40%" }} />
            )}
          </div>

          {document.fileName}

          {document.sendToApp && (
            <Icon
              name="mobile alternate"
              className="tile-send-to-app"
              title={sendToAppTitle}
            />
          )}

          <div className="tile-actions-overlay">{actionsNode}</div>
        </Tile>
      }
    >
      {document.description && (
        <Fragment>
          <PopupHeader>Document Description</PopupHeader>
          <PopupContent>{document.description}</PopupContent>
        </Fragment>
      )}
      <PopupContent>
        Uploaded{" "}
        <Format.DateTime
          value={document.createdUtc}
          format="DD MMM YYYY HH:mm"
        />
      </PopupContent>
    </Popup>
  );
};

export default ThumbnailTile;
